import React, { ReactNode, useState, useEffect } from 'react';
import { Hint as FrontonHint, HintContent, HintCloseButton } from 'fronton-react';
import { gaShowElement } from 'ga-events/ga-view-element';

export const Hint = ({
  hintText,
  children,
  title,
}: {
  hintText: string;
  children: ReactNode;
  title: string;
}) => {
  const [isShowHint, setIsShowHint] = useState<boolean>(false);

  const handleClickHint = () => {
    setIsShowHint(false);
  };

  useEffect(() => {
    if (isShowHint) {
      gaShowElement({ title });
    }
  }, [isShowHint, title]);

  return (
    <FrontonHint
      anchor={
        <div onMouseEnter={() => setIsShowHint(!isShowHint)} onMouseLeave={() => setIsShowHint(!isShowHint)}>
          {children}
        </div>
      }
      placement="top"
      open={isShowHint}
      closeButton={<HintCloseButton onClick={handleClickHint} />}>
      <HintContent paragraph={hintText} />
    </FrontonHint>
  );
};
